module.exports = "/_next/static/images/default-bg-80b4061b48293fa7065567f8a6e1964c.png";